import {Async, Empty} from 'Core/models/Async';
import {LegalDocument, LegalDocumentText} from 'Core/models/LegalDocument';
import {createAction} from 'Shared/utilities/actionCreator';

export enum LegalDocumentActionType {
  GET_DOCUMENT_SUMMARIES = 'legalDocument/GET_DOCUMENT_SUMMARIES',
  LOAD_DOCUMENT_SUMMARIES = 'legalDocument/LOAD_DOCUMENT_SUMMARIES',
  GET_DOCUMENT_TEXT = 'legalDocument/GET_DOCUMENT_TEXT',
  LOAD_DOCUMENT_TEXT = 'legalDocument/LOAD_DOCUMENT_TEXT',
  CLEAR = 'legalDocument/CLEAR',
}

export const clear = () => createAction(LegalDocumentActionType.CLEAR);
export const getDocumentSummaries = () => createAction(LegalDocumentActionType.GET_DOCUMENT_SUMMARIES);
export const loadDocumentSummaries = (documentSummaries: Async<LegalDocument[]>) =>
  createAction(LegalDocumentActionType.LOAD_DOCUMENT_SUMMARIES, documentSummaries);
export const getDocumentText = (id: string) => createAction(LegalDocumentActionType.GET_DOCUMENT_TEXT, {id});
export const loadDocumentText = (documentText: Async<LegalDocumentText>) =>
  createAction(LegalDocumentActionType.LOAD_DOCUMENT_TEXT, documentText);

type LegalDocumentState = {
  documents: Async<LegalDocument[]>;
  documentText: Async<LegalDocumentText>;
};

const DEFAULT_STATE: LegalDocumentState = {
  documents: new Empty(),
  documentText: new Empty(),
};

type LegalDocumentAction = ReturnType<typeof loadDocumentSummaries> | ReturnType<typeof loadDocumentText>
| ReturnType<typeof clear>;

export default (state: LegalDocumentState = DEFAULT_STATE, action: LegalDocumentAction): LegalDocumentState => {
  switch (action.type) {
    case LegalDocumentActionType.LOAD_DOCUMENT_SUMMARIES:
      return {
        ...state,
        documents: action.payload,
      };
    case LegalDocumentActionType.LOAD_DOCUMENT_TEXT:
      return {
        ...state,
        documentText: action.payload,
      };
    case LegalDocumentActionType.CLEAR:
      return DEFAULT_STATE;
    default:
      return state;
  }
};
